<template>
  <div class="">
    <PreLoader v-if="isLoading" />
    <ExceptionWithImg v-if="exceptionMsg" :msg="exceptionMsg" />

    <BranchTimeForm
      v-if="!isLoading"
      :brancTimehData="brancTimehData"
      :submitName="$t('add')"
      v-on:addOrUpdateBranchTime="addBranchTime"
    />
  </div>
</template>

<script>
import PreLoader from "@/components/general/PreLoader.vue";
import ExceptionWithImg from "@/components/general/ExceptionWithImg.vue";
import { STATUS } from "@/utils/constants";
import BranchTimeForm from "@/components/branchesTimes/BranchTimeForm.vue";
import BranchTime from "@/models/branchesTimes/BranchTime";
import createToastMixin from "@/utils/create-toast-mixin";

export default {
  name: "BranchTimeAdd",
  mixins: [createToastMixin],
  components: {
    PreLoader,
    ExceptionWithImg,
    BranchTimeForm,
  },
  data() {
    return {
      isLoading: false,
      exceptionMsg: null,
      exceptionImg: null,
      language: localStorage.getItem("userLanguage") || "ar",
      userAuthorizeToken:
        this.$store.getters.userData.userPersonalData.userAuthorizeToken ||
        null,
      brancTimehData: new BranchTime(),
    };
  },
  methods: {
    async addBranchTime() {
      this.isLoading = true;
      try {
        let response = await this.brancTimehData.addOrUpdateBranchTime(
          this.language,
          this.userAuthorizeToken
        );
        if (response.data.status == STATUS.SUCCESS) {
          this.showMsg(response.data.msg, true);
          this.brancTimehData.setInitialValue();
        } else if (response.data.status == STATUS.INVALID_TOKEN) {
          this.showMsg(response.data.msg);
          this.$store.dispatch("logoutUser");
          this.$router.push("/").catch(() => {});
        } else {
          this.showMsg(response.data.msg);
        }
      } catch (e) {
        this.showMsg(this.$t("errorCatch"));
      }
      this.isLoading = false;
    },
  },
  async created() {
    this.brancTimehData.branchToken = this.$store.getters.branchToken;
  },
};
</script>

<style scoped lang="scss"></style>
